import { PlatformEnum } from 'constants-activate';
import {IntegrationDefinition} from '../IntegrationDefinition';
import { PackagedTypeEnum } from '../../properties/PackagedTypeEnum';
import { Password } from '../../properties/baseTypes';
import { PERMISSION_KEYS } from 'constants-permissions';
import { SecurityRuleTypeEnum } from '../../properties/PropertySecurity';

import {
  IntegrationCategoryEnum,
  IntegrationProviderEnum,
  IntegrationTypeEnum,
} from 'constants-integrations';

const VantifyDefinition: IntegrationDefinition = {
  name: IntegrationProviderEnum.Vantify,
  hasCustomUI: true,
  friendlyName: 'Vantify Work Order',
  description: 'Defines the properties required for a Vantify integration',
  category: IntegrationCategoryEnum.Maintenance,
  platforms: [PlatformEnum.Web, PlatformEnum.Mobile],
  type: IntegrationTypeEnum.Api,
  settings: {},
  properties: {
    subHeading: {
      type: String.name,
      validators: [],
      friendlyName:
        'Enter your Vantify account credentials, load available sites, and configure settings to enable work order management.',
    },
    apiUrl: {
      type: 'Url',
      friendlyName: 'API Base URL',
      tags: ['metadataFieldRequest'],
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
      fixedLabel: true,
      secure: {
        read: [
          {
            type: SecurityRuleTypeEnum.ChannelPermission,
            value: PERMISSION_KEYS.PERMISSION_INTEGRATION_READ,
          },
        ],
      },
    },
    username: {
      type: String.name,
      friendlyName: 'Username',
      tags: ['metadataFieldRequest'],
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
      fixedLabel: true,
      secure: {
        read: [
          {
            type: SecurityRuleTypeEnum.ChannelPermission,
            value: PERMISSION_KEYS.PERMISSION_INTEGRATION_READ,
          },
        ],
      },
    },
    password: {
      type: Password.name,
      friendlyName: 'Password',
      tags: ['metadataFieldRequest'],
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
      fixedLabel: true,
      secure: {
        read: [
          {
            type: SecurityRuleTypeEnum.ChannelPermission,
            value: PERMISSION_KEYS.PERMISSION_INTEGRATION_READ,
          },
        ],
      },
    },
    siteId: {
      friendlyName: 'Site ID',
      type: String.name,
      description: 'Enter the site ID for this integration',
      tags: ['metadataFieldRequest'],
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
      fixedLabel: true,
      secure: {
        read: [
          {
            type: SecurityRuleTypeEnum.ChannelPermission,
            value: PERMISSION_KEYS.PERMISSION_INTEGRATION_READ,
          },
        ],
      },
    },
    loadSettingButton: {
      friendlyName: 'Load settings',
      type: String.name,
      validators: [],
    },
    disableVantifyWebhookNotifications: {
      friendlyName: 'Disable webhook notifications',
      type: 'Boolean',
      description: 'When checked, Activate will not send Vantify webhook notifications.',
      default: false,
    },
    autoApproveWorkOrders: {
      friendlyName: 'Auto-approve work orders for selected domains.',
      type: 'Boolean',
      default: false,
    },
    approvedDomains: {
      packagedType: PackagedTypeEnum.MultiSelect,
      friendlyName:
        'Enter all domain names that would have all submitted work orders automatically approved',
      type: 'String',
      tags: ['metadataFieldResponse'],
      isArray: true,
      validators: [
        {
          name: 'ArrayMin',
          value: 1,
        },
        {
          name: 'Includes',
          value: '^(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,}$',
        },
      ],
      isFullWidth: true,
    },
    tenantMappings: {
      friendlyName: 'Site tenant mapping',
      type: String.name,
      tags: ['metadataFieldResponse'],
      validators: [],
    },
  },
};

export const definition = VantifyDefinition;
